import { css } from '@emotion/react';
import React from 'react';

import Card from '@/core/components/layout/Card.component';
import { Spacer } from '@/ui/spacing';
import { useSpaceMatchingKey } from '@/ui/theme';
import { BodySmall, Heading } from '@/ui/typography';

import { MoreInfoCard } from './MoreInfoCard.component';

interface MoreInfoCardsProps {
  title: string;
  items: {
    name: string;
    description?: string;
    image: {
      source: string;
      id: string;
      altText: string;
    };
    url: string;
  }[];
  className?: string;
  description?: string;
}

export const MoreInfoCardSection = (props: MoreInfoCardsProps) => {
  return (
    <Card className={props.className}>
      <Heading style="heading5" as="h5">
        {props.title}
      </Heading>
      {props.description && (
        <>
          <Spacer s="s" />
          <BodySmall>{props.description}</BodySmall>
        </>
      )}
      <Spacer s="s" />
      <div
        css={css`
          display: grid;
          column-gap: ${useSpaceMatchingKey('l')};
          row-gap: ${useSpaceMatchingKey('xl')};
          flex-wrap: wrap;
          grid-template-columns: 1fr 1fr 1fr;

          @media all and (max-width: 1100px) {
            grid-template-columns: 1fr 1fr;
          }

          @media all and (max-width: 1100px) {
            grid-template-columns: 1fr 1fr;
          }

          @media all and (max-width: 650px) {
            grid-template-columns: 1fr;
          }
        `}
      >
        {props.items.map((item) => (
          <MoreInfoCard key={item.name} {...item} />
        ))}
      </div>
    </Card>
  );
};
